import { ApolloError, gql, useMutation } from "@apollo/client";
import React from "react";
import {
  DelGoodMutation,
  DelGoodMutationVariables,
} from "../generated/graphql";

const DEL_GOOD_MUTATION = gql`
  mutation delGood($input: DelGoodInput!) {
    delGood(input: $input) {
      ok
      err
    }
  }
`;

export const useDelGood = (
  onCompleted?: (data: DelGoodMutation) => void,
  onError?: (Error: ApolloError) => void
) => {
  return useMutation<DelGoodMutation, DelGoodMutationVariables>(
    DEL_GOOD_MUTATION,
    {
      onCompleted,
      onError,
    }
  );
};
